import pick from 'lodash/pick';
import { resourceFields } from '../data/Constants';

const optionFieldKeys = ['id'];
resourceFields.options.forEach(({ key }) => { if (!['customizations', 'outOfStock'].includes(key)) optionFieldKeys.push(key); });

/**
 * Removes keys used for display that the API doesn't accept
 */
const cleanOptionsKeysForRequests = (option) => {
  const cleanedOption = pick(option, optionFieldKeys);
  return cleanedOption;
};

export {
  cleanOptionsKeysForRequests,
};
